const PageApplication = require('../common/frontend/application');

import homeDesktopApplication from './desktop/frontend/application';

PageApplication.initialize();
homeDesktopApplication.initialize();
